module.exports = __webpack_public_path__ + "static/media/procast_header_1791_540.71be2834.png";